import Vue from 'vue';
import Toasted from 'vue-toasted';

Vue.use(Toasted);

const tsuccess = {
    type: 'success',
    icon: 'favorite_border',
    position: 'top-center',
    duration: 3000,
    fullWidth: true,
    position: 'bottom-center'
};

const tfailure = {
    type: 'error',
    icon: 'error_outline',
    position: 'top-center',
    duration: 3000,
    fullWidth: true,
    position: 'bottom-center'
};

Vue.toasted.register('error', e => e.message, tfailure);
Vue.toasted.register('success', p => p.message, tsuccess);
